import { MapRef } from 'react-map-gl';

export function addStringLineLayer(
  map: MapRef,
  stringLineLayerId: string,
  stringLineSourceId: string
) {
  try {
    const mapInstance = map.getMap();
    const layer = mapInstance.getLayer(stringLineLayerId);
    if (layer) return;

    mapInstance.addLayer({
      id: stringLineLayerId,
      type: 'line',
      source: stringLineSourceId,
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': '#0CACA6',
        'line-width': 5,
      },
    });
  } catch (error) {
    // TODO: failing silently -- styles load after our data
    // map.loaded() didn't really work in ensuring the styles loaded first
    // This is a temp workaround
    // console.error(error);
    // console.error('layerId for above error', stringLineLayerId);
    // console.error('sourceId for above error', stringLineSourceId);
  }
}
